import { api } from "../utils/api";
import UserStore from "../utils/UserStore";
import isClassDiaryDemo from "../demo/isClassDiaryDemo";
import { DEMO_TURMA_DISC } from "../demo/buildDemoOccurrences";
import { buildDemoGridFrequency } from "../demo/buildDemoGridFrequency";

function responseHasGridShape(data) {
  return (
    data != null &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    Array.isArray(data.groups) &&
    Array.isArray(data.headers)
  );
}

function normalizePeriodSummaries(data) {
  if (!data || !Array.isArray(data.periodSummaries)) {
    return [];
  }
  return data.periodSummaries;
}

/**
 * Se a API devolver [] ou formato inesperado (comum sem backend / sem rota), a turma demo
 * (`idTurmaDisc` 88001) continua com grade gerada localmente.
 */
const getFrequency = async (idTurmaDisc, dateFrom, dateTo) => {
  if (isClassDiaryDemo()) {
    return buildDemoGridFrequency(idTurmaDisc, dateFrom, dateTo);
  }

  try {
    const res = await api.get("ClassDiaryV1/gridFrequency", {
      params: {
        idTurmaDisc,
        dateFrom,
        dateTo
      }
    });
    if (responseHasGridShape(res.data)) {
      return {
        groups: res.data.groups,
        headers: res.data.headers,
        lines: res.data.lines || [],
        periodSummaries: normalizePeriodSummaries(res.data)
      };
    }
  } catch {
    /* API indisponível ou rota ausente — fallback abaixo para turma demo */
  }

  if (String(idTurmaDisc) === String(DEMO_TURMA_DISC)) {
    return buildDemoGridFrequency(idTurmaDisc, dateFrom, dateTo);
  }

  return { groups: [], headers: [], lines: [], periodSummaries: [] };
};

const saveFrequencyJob = async data => {
  const res = await api.post("ClassDiaryV1/frequency/job", {
    ...data,
    externalData: UserStore.getUserExternalInfo()
  });
  return res.data;
};

const getFrequencySettings = async () => {
  const res = await api.get("ClassDiaryV1/frequency/settings");
  return res.data;
};

const getAbsenceJustificationReasons = async () => {
  if (isClassDiaryDemo()) {
    return [];
  }
  const res = await api.get(
    "ClassDiaryV1/gridFrequency/justification-reasons"
  );
  return Array.isArray(res.data) ? res.data : [];
};

export default {
  getFrequency,
  saveFrequencyJob,
  getFrequencySettings,
  getAbsenceJustificationReasons
};
